export default "/images/0c84c778f591a8062d72f9e591909839.png";